import React from "react"
import { Link } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { Button } from "reactstrap"

// Components
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import GlobalCreateMemberAction from "../CommonForBoth/TopbarDropdown/GlobalCreateMemberAction"
import GlobalMemberSearch from "../CommonForBoth/TopbarDropdown/GlobalMemberSearch"
import GlobalTVAction from "../CommonForBoth/TopbarDropdown/GlobalTVAction"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import withRouter from "../Common/withRouter"

// Images
import neoLogo from "../../assets/images/Neo_Logo_A.svg"

// Hooks
import { useLayout } from "../../hooks/useLayout"

const Header = props => {

  const { toggleSidebar } = useLayout();
  
  // O slug da branch deve ser derivado dependendo se suportaremos múltiplas branches depois,
  // ou lido do tenant/claims. Por hora, assumir que é 'default' ou ignorar.
  const dashboardLink = "/dashboard"; // Simplicado para /dashboard, já que removi slug na config.

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex align-items-center">
            <div className="navbar-brand-box">
              <Link to={dashboardLink} className="logo logo-dark">
                <span className="logo-sm">
                  <img src={neoLogo} alt="" height="22" style={{ filter: "brightness(0) invert(1)" }} />
                </span>
                <span className="logo-lg">
                  <img src={neoLogo} alt="" height="28" style={{ filter: "brightness(0) invert(1)" }} />
                </span>
              </Link>
              <Link to={dashboardLink} className="logo logo-light">
                <span className="logo-sm">
                  <img src={neoLogo} alt="" height="22" style={{ filter: "brightness(0) invert(1)" }} />
                </span>
                <span className="logo-lg">
                  <img src={neoLogo} alt="" height="28" style={{ filter: "brightness(0) invert(1)" }} />
                </span>
              </Link>
            </div>
            <Button size="sm" color="none" type="button" onClick={toggleSidebar} className="px-3 font-size-16 header-item waves-effect" id="vertical-menu-btn">
              <i className="fa fa-fw fa-bars"></i>
            </Button>
          </div>

          <div className="d-flex align-items-center">
            <GlobalMemberSearch />
            <GlobalTVAction />
            <GlobalCreateMemberAction />
            <NotificationDropdown />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(Header))
